import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/zhezhao-1.png'
import _imports_1 from '../images/zhezhao-2.png'
import _imports_2 from '../images/zhezhao-3.png'
import _imports_3 from '../images/otimes.png'
import _imports_4 from '../images/swiper-1.png'
import _imports_5 from '../images/swiper-2.png'
import _imports_6 from '../images/plastics-img-1.png'
import _imports_7 from '../images/text-con-1.png'
import _imports_8 from '../images/plastics-img-2.png'
import _imports_9 from '../images/text-con-2.png'
import _imports_10 from '../images/plastics-img-3.png'
import _imports_11 from '../images/text-con-3.png'
import _imports_12 from '../images/plastics-img-4.png'
import _imports_13 from '../images/text-con-4.png'
import _imports_14 from '../images/plastics-img-5.png'
import _imports_15 from '../images/text-con-5.png'
import _imports_16 from '../images/steel-img-1.png'
import _imports_17 from '../images/text-con-6.png'
import _imports_18 from '../images/steel-img-2.png'
import _imports_19 from '../images/text-con-7.png'
import _imports_20 from '../images/steel-img-3.png'
import _imports_21 from '../images/text-con-8.png'
import _imports_22 from '../images/steel-img-4.png'
import _imports_23 from '../images/text-con-9.png'
import _imports_24 from '../images/chemicals-img-1.png'
import _imports_25 from '../images/text-con-10.png'
import _imports_26 from '../images/chemicals-img-2.png'
import _imports_27 from '../images/text-con-11.png'
import _imports_28 from '../images/video-cover.png'
import _imports_29 from '../images/line-bg.png'
import _imports_30 from '../images/About-Us-title.png'
import _imports_31 from '../images/more.png'
import _imports_32 from '../images/more-active.png'
import _imports_33 from '../images/history.png'
import _imports_34 from '../images/history-more.png'
import _imports_35 from '../images/history-more-active.png'
import _imports_36 from '../images/history-img.png'
import _imports_37 from '../images/history-bg-1.png'
import _imports_38 from '../images/history-bg-2.png'
import _imports_39 from '../images/footer-button-2.png'
import _imports_40 from '../images/footer-button-2-active.png'
import _imports_41 from '../images/partners-list.png'


const _withScopeId = n => (_pushScopeId("data-v-7a155198"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "zhezhao-one",
  src: _imports_0,
  alt: "zhezhao-1"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "zhezhao-two",
  src: _imports_1,
  alt: "zhezhao-2"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "zhezhao-three",
  src: _imports_2,
  alt: "zhezhao-3"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "word" }, "2", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "otimes",
  src: _imports_3,
  alt: "otimes"
}, null, -1))
const _hoisted_7 = { class: "swiper-con" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"1200px","margin-top":"20px"},
  src: _imports_4,
  alt: "Our values: Open mindednessCooperation, Eco-friendly,Social conscience Innovation"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"1200px","margin-top":"50px"},
  src: _imports_5,
  alt: "Provide customized solutions of supply chain management"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-7a155198><div class=\"pic-box\" data-v-7a155198><p class=\"title-pic\" data-v-7a155198>PLASTIC MATERIALS</p></div></div><div class=\"plastics-main\" data-v-7a155198><div class=\"list-one\" data-v-7a155198><div class=\"list-con\" data-v-7a155198><img src=\"" + _imports_6 + "\" alt=\"Thermoplastics Elastomer\" data-v-7a155198><a href=\"/products/similar-goods.html?type=TPU\" class=\"message-a\" data-v-7a155198><div class=\"massage-con\" data-v-7a155198><img src=\"" + _imports_7 + "\" alt=\"Thermoplastics Elastomer materials includeTPE,TPU,TPEE，TPV，TPO from BASF,Polyene, Covestro AG, Coim Group,Dupont,SK, WANHUA, Miracll. These materials are widely used in solar facility，cable and wire jacket,communication product, electric and electronic products based on their special properties\" data-v-7a155198></div></a></div><div class=\"list-con\" data-v-7a155198><img src=\"" + _imports_8 + "\" alt=\"General purpose plastics\" data-v-7a155198><a href=\"/products/similar-goods.html?type=ABS\" class=\"message-a\" data-v-7a155198><div class=\"massage-con\" data-v-7a155198><img src=\"" + _imports_9 + "\" alt=\"General purpose plastics include PP, PE,PVC,HIPS,GPPS,EPS,AS,ABS from SINOPEC,CNPC,LG, CHIMEI,DAGU.These materials are mainly used in home appliances,automobile, flms, agriculture and packaging\" data-v-7a155198></div></a></div></div><div class=\"list-two\" data-v-7a155198><div class=\"list-con list-con-special\" data-v-7a155198><img src=\"" + _imports_10 + "\" alt=\"Engineering plastics\" data-v-7a155198><a href=\"/products/similar-goods.html?type=PC\" class=\"message-a\" data-v-7a155198><div class=\"massage-con\" data-v-7a155198><img src=\"" + _imports_11 + "\" alt=\"Engineering plastics include PET,PBT,PC,PA,POM, PMMA from CHIMEI,Lotte,CPP,Yuntianhua, SHENMA,BASF. These materials are widely applied to home-appliances, automotive parts, electricity,\" data-v-7a155198></div></a></div><div class=\"list-con\" data-v-7a155198><img src=\"" + _imports_12 + "\" alt=\"Additives\" data-v-7a155198><a href=\"/products/similar-goods.html?type=Additives\" class=\"message-a\" data-v-7a155198><div class=\"massage-con\" data-v-7a155198><img src=\"" + _imports_13 + "\" alt=\"Additives include the POE, antioxidants,flame retardants. glass fiber,titaniumdioxide,ABS with high contents of rubber from BASF,JUSHI, SK, LG, KUMHOChemical.These materials are widelyused for modified plastic materials and related products.\" data-v-7a155198></div></a></div><div class=\"list-con\" data-v-7a155198><img src=\"" + _imports_14 + "\" alt=\"Biodegradable Plastic\" data-v-7a155198><a href=\"/products/similar-goods.html?type=PLA\" data-v-7a155198><div class=\"massage-con\" data-v-7a155198><img src=\"" + _imports_15 + "\" alt=\"Biodegradable Plastic material includesPLA,PBAT,PLA compound etc., fromFengyuan, Blue Ridge Tunhe and ChangChun group.These materials are widelyapplied to packaging, film, tableware,cloth and etc.\" data-v-7a155198></div></a></div></div><div class=\"footer\" data-v-7a155198></div></div>", 2)
const _hoisted_12 = [
  _hoisted_10
]
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"steel-bg\" data-v-7a155198></div><div class=\"title\" data-v-7a155198><div class=\"pic-box\" data-v-7a155198><p class=\"title-pic\" data-v-7a155198>STEEL SHEETS</p></div></div><div class=\"steel-main\" data-v-7a155198><div class=\"list-one\" data-v-7a155198><div class=\"list-con\" data-v-7a155198><img src=\"" + _imports_16 + "\" alt=\"Silicon Steel\" data-v-7a155198><a href=\"/products/similar-goods.html?type=Silicon Steel Sheet\" class=\"message-a\" data-v-7a155198><div class=\"massage-con\" data-v-7a155198><img src=\"" + _imports_17 + "\" alt=\"Silicon steels are ferritic alloys of iron andsilicon that have magnetic properties whichmake them useful in motors and transformers.We can provide Silicon steels from ANSTEEL,BAOSTEEL，BAOWu,SHAGANG Group，and SHOUGANG...\" data-v-7a155198></div></a></div><div class=\"list-con\" data-v-7a155198><img src=\"" + _imports_18 + "\" alt=\"(P&amp;O)Steel Plates\" data-v-7a155198><a href=\"/products/similar-goods.html?type=Pickling Steel\" class=\"message-a\" data-v-7a155198><div class=\"massage-con\" data-v-7a155198><img src=\"" + _imports_19 + "\" alt=\"(P&amp;O) steel plates are an excellent candidatefor most processing techniques.(P&amp;O) steelhave smooth, blue-grey finish. P&amp;O plates are standard hot rolled steel sheets that hasundergone a &#39;pickling&#39; process, meaning theplates have been dipped into an acid in orderto remove the mill scale from its surface.\" data-v-7a155198></div></a></div><div class=\"list-con\" data-v-7a155198><img src=\"" + _imports_20 + "\" alt=\"Cold Rolled Steel\" data-v-7a155198><a href=\"/products/similar-goods.html?type=Cold Rolled Steel\" class=\"message-a\" data-v-7a155198><div class=\"massage-con\" data-v-7a155198><img src=\"" + _imports_21 + "\" alt=\"Cold worked steels are typically harder andstronger than standard hot rolled steels.Cold rolled steel is essentially hot rolled steelthat has been through further processing.Once hot rolled steel has cooled, it is then re-rolled at room temperature to achieve moreexact dimensions and better surface qualities.\" data-v-7a155198></div></a></div><div class=\"list-con\" data-v-7a155198><img src=\"" + _imports_22 + "\" alt=\"Galvanized Steel\" data-v-7a155198><a href=\"/products/similar-goods.html?type=Galvanized Steel\" class=\"message-a\" data-v-7a155198><div class=\"massage-con\" data-v-7a155198><img src=\"" + _imports_23 + "\" alt=\"Galvanized steel is among the most popularsteel type because of its extended durability,having the strength and formability of steel aswell as the corrosion protection of coating ofzinc-iron.The zinc protects the base metal byacting as a barrier to corrosive elements, andthe sacrificial nature of the coating results ina long-lasting and high-quality steel product.\" data-v-7a155198></div></a></div></div><div class=\"footer\" data-v-7a155198></div></div>", 3)
const _hoisted_16 = [
  _hoisted_13
]
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"chemicals\" data-v-7a155198><div class=\"steel-bg\" data-v-7a155198></div><div class=\"title\" data-v-7a155198><div class=\"pic-box\" data-v-7a155198><p class=\"title-pic\" data-v-7a155198>CHEMICALS</p></div></div><div class=\"steel-main\" data-v-7a155198><div class=\"list-one\" data-v-7a155198><div class=\"list-con\" data-v-7a155198><img src=\"" + _imports_24 + "\" alt=\"Monomer\" data-v-7a155198><div class=\"massage-con\" data-v-7a155198><img src=\"" + _imports_25 + "\" alt=\"Methanol, Benzene, Styrene,Ethylene,Propylene and etc.\" data-v-7a155198></div></div><div class=\"list-con\" data-v-7a155198><img src=\"" + _imports_26 + "\" alt=\"Oleochemicals\" data-v-7a155198><div class=\"massage-con\" data-v-7a155198><img src=\"" + _imports_27 + "\" alt=\"Palm fatty acid distillate (PFAD) is a by-product in the refining process of Palm oil.-Palm methyl ester (PME) production fromPFAD is kind of biodiesel, which is a green andsustainable energy compared with fossil energy.PME can be used as a raw material ofenvironment friendly plasticizer also.\" data-v-7a155198></div></div></div><div class=\"footer\" data-v-7a155198></div></div></div>", 1)
const _hoisted_18 = { class: "company-con" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "company-bg" }, null, -1))
const _hoisted_20 = { class: "company-main" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title-con" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "title-pic" }, "COMPANY")
  ])
], -1))
const _hoisted_22 = { class: "video-con" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "line",
  src: _imports_29,
  alt: "line-bg"
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "title-right",
  src: _imports_30,
  alt: "OTIMES about us"
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-content" }, [
  /*#__PURE__*/_createElementVNode("p", null, " OTIMES was established in Shenzhen, China，in 2016 , adhering to the core corporate values of \"Social Conscience，Innovation，Open Mindedness，Cooperation and Eco-Friendly \", relying on industry background and team advantages, Our major products are steel, Cold rolled steel, Silicon Steel, (P&O) steel, plastic raw materials, engineering plastics and bio-based materials. We provide supply chain services such as information, smart … ")
], -1))
const _hoisted_26 = { class: "footer" }
const _hoisted_27 = { class: "link-box" }
const _hoisted_28 = { class: "history-con" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "history-bg" }, null, -1))
const _hoisted_30 = { class: "history-box" }
const _hoisted_31 = { class: "title" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "title-img",
  src: _imports_33,
  alt: "OTIMES Company History"
}, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "history-main" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "history-img",
    src: _imports_36,
    alt: "otimes company building"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "history-bg-one",
    src: _imports_37,
    alt: "history-bg-1"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "history-bg-two",
    src: _imports_38,
    alt: "history-bg-2"
  })
], -1))
const _hoisted_34 = { class: "footer-con" }
const _hoisted_35 = { class: "button-con" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-pic" }, "PARTNERS", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ad-con" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "partners-list",
    src: _imports_41,
    alt: "OTIMES PARTNERS"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_BackTop = _resolveComponent("BackTop")!
  const _component_ChatBox = _resolveComponent("ChatBox")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_CookieBox = _resolveComponent("CookieBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopBar),
    _createVNode(_component_el_carousel, {
      width: "100%",
      height: "480px"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_carousel_item, null, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_el_carousel_item, null, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: "plastics-con",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setActiveName('PLASTICS MATERIAL')))
    }, _hoisted_12),
    _createElementVNode("div", {
      class: "steel-con",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActiveName('STEELS MATERIAL')))
    }, _hoisted_16),
    _hoisted_17,
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("img", {
            class: "video-cover",
            src: _imports_28,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/about.html'))),
            alt: "OTIMES about us"
          }),
          _hoisted_23
        ]),
        _hoisted_24,
        _hoisted_25
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_el_link, { underline: false }, {
            default: _withCtx(() => [
              (_ctx.moreTag == 1)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.moreTag = 2)),
                    class: "more",
                    src: _imports_31,
                    alt: "otimes more message"
                  }, null, 32))
                : _createCommentVNode("", true),
              (_ctx.moreTag == 2)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.moreTag = 1)),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/about.html'))),
                    class: "more",
                    src: _imports_32,
                    alt: "otimes more message"
                  }, null, 32))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _hoisted_29,
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createVNode(_component_el_link, { underline: false }, {
            default: _withCtx(() => [
              (_ctx.historyMoreTag == 1)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    onMouseenter: _cache[6] || (_cache[6] = ($event: any) => (_ctx.historyMoreTag = 2)),
                    class: "more",
                    src: _imports_34,
                    alt: "otimes history more"
                  }, null, 32))
                : _createCommentVNode("", true),
              (_ctx.historyMoreTag == 2)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.historyMoreTag = 1)),
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push('/history.html'))),
                    class: "more",
                    src: _imports_35,
                    alt: "otimes history more"
                  }, null, 32))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _hoisted_33
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _hoisted_36,
        _createVNode(_component_el_link, { underline: false }, {
          default: _withCtx(() => [
            (_ctx.buttonTag == 1)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "learn-more",
                  onMouseenter: _cache[9] || (_cache[9] = ($event: any) => (_ctx.buttonTag = 2)),
                  src: _imports_39,
                  alt: "footer-button-2"
                }, null, 32))
              : _createCommentVNode("", true),
            (_ctx.buttonTag == 2)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "learn-more",
                  onMouseleave: _cache[10] || (_cache[10] = ($event: any) => (_ctx.buttonTag = 1)),
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$router.push('/partners.html'))),
                  src: _imports_40,
                  alt: "footer-button-2-active"
                }, null, 32))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_37,
    _createVNode(_component_BackTop),
    _createVNode(_component_ChatBox),
    _createVNode(_component_Footer),
    _createVNode(_component_CookieBox)
  ]))
}